import { useQuery } from "@tanstack/react-query";
import { getRanking } from "../services/ranking-service";
import type {
	RankingListParams,
	RankingPaginatedResponse,
} from "../types/ranking";

export function useRankingList(params: RankingListParams) {
	return useQuery<RankingPaginatedResponse>({
		queryKey: ["tracking", "ranking", params],
		queryFn: () => getRanking(params),
		enabled:
			params.pageNumber >= 1 &&
			params.pageSize >= 1 &&
			Boolean(params.startDate) &&
			Boolean(params.endDate),
	});
}
